<div id="add-image" [style.height]="height" [style.width]="width">
    <div class="instructions">
      Suggested formats<br>JPG, PNG, WEBP, SVG
    </div>
    <div class="instructions2">
      Recommended Size:<br>{{sizeRecommendation}}
    </div>
    
    <div id="buttons">
      <input type="file" accept="image/*" (change)="onFileSelected($event)" 
        #uploadInput [id]="randomId" style="display:none">
      <ion-button size="small" (click)="upload()">Upload New</ion-button>
      <ion-button size="small" (click)="library()" *ngIf="includeLibraryButton">Media Library</ion-button>
    </div>
</div>